export const getRoomLogoUrl = (name: string) => {
    const cleanName = name.replace('(EUR)', '').replace('(ES-PT)', '').replace(/[^a-z0-9\\.]/ig, '').trim();

    return `${process.env.PUBLIC_URL}/assets/images/logos/${cleanName}.svg`;
};
